// Motivos de cancelamento aceitos pela API da 99Entrega (POST /v2/order/cancel).
// Fonte única usada pelo seletor (SEntrega99Cancel) e pela exibição (SEntrega99Info).
export default [
  {
    codigo: "410013",
    texto: "nenhum entregador aceitou o pedido por um longo período",
  },
  { codigo: "410014", texto: "informações do produto incorretas" },
  { codigo: "410015", texto: "método de pagamento selecionado incorretamente" },
  { codigo: "410016", texto: "endereço de entrega incorreto" },
  {
    codigo: "410017",
    texto: "informações de contato do destinatário incorretas",
  },
  { codigo: "410018", texto: "entrega não necessária" },
  { codigo: "410019", texto: "entregador não tem troco" },
  { codigo: "410020", texto: "entregador não coletou o item" },
  { codigo: "410021", texto: "não foi possível contatar o entregador" },
];
